module.exports = __webpack_public_path__ + "img/house-icon.11528f83.png";